<div [ngStyle]="{'pointer-events' : (alerts?.show | async)? 'none' : ''}">
  <div class="body" [ngStyle]="{'pointer-events' : (alerts?.show | async)? 'none' : ''}">
    <div class="row ">
      <div class="col-md-5 offset-md-6 pt-2 pb-2">
        <div class="aml-text ">
          <img
            src="../../assets/images/aml-logo.png"
            class="logo"
            alt="Responsive image"
          />
        </div>

        <div class="login-form ">

          <ng-container *ngIf="showerror">
            <span
              class=" d-flex justify-content-center text-danger ml-5"
            >{{errorText}}</span>
          </ng-container>

          <ng-container  *ngIf="isEmpty">
           <span
             class=" d-flex justify-content-center text-danger ml-5">
          Please fill the form!</span>
          </ng-container>


          <form class="main-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group  pt-2 position-relative">
              <i class="fa fa-user fa-2x icon"></i>
              <input
                type="user"
                class="form-control user"
                formControlName="username"
                name="user"
                placeholder="loginId"
              />
              <span
                *ngIf="
                !loginForm.controls.username.pristine &&
                loginForm.controls.username.invalid
              "
                class="text-danger ml-5"
              >Please insert LoginId!</span
              >
            </div>

            <div class="form-group pt-2 position-relative">
              <i class="fa fa-lock fa-2x icon"></i>
              <i (click)="visibility = !visibility" [ngClass]="visibility ? ' fa-eye-slash' : 'fa-eye'" class="fa text-muted float-right field-icon"></i>
              <input
                [type]="visibility ?  'text':'password'"
                class="form-control pass"
                formControlName="password"
                name="password"
                placeholder="Password"
              />

              <span
                *ngIf="
                !loginForm.controls.password.pristine &&
                loginForm.controls.password.invalid
              "
                class="text-danger ml-5"
              >Please insert password!</span
              >
            </div>

            <!--          <div class="form-check-inline pl-5 pt-3 custom-control custom-checkbox">-->
            <!--            <input type="checkbox"  class="form-check-input custom-control-input">-->
            <!--            <label class="form-check-label custom-control-label">Remember Me</label>-->
            <!--          </div>-->

            <!-- <div class=" form-check-inline custom-control custom-checkbox pt-3">
               <input
                 type="checkbox"
                 class="form-check-input custom-control-input"
                 id="customCheck1"
                 (change)="remember = !remember"
                 [checked]="remember"
               />
               <label
                 style="color: #E2136E"
                 class="custom-control-label form-check-label"
                 for="customCheck1"
                 >Remember Me</label
               >
             </div> -->

            <a [routerLink]="['/recover']"  class="forgot card-link pt-3" href="" (click)="$event.preventDefault()">Forgot Password?</a>

            <br /><br />

            <div class="form-group pt-3">
              <!-- [disabled]="loginForm.invalid" -->
              <!-- [ngClass]="loginForm.invalid ? 'disabled' : ''" -->
              <button class="btn btn-primary btn-block" type="submit">
                Log In
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2"></div>
    </div>
  </div>
</div>

<div *ngIf="alerts?.show | async"
     style=" pointer-events: none;position:fixed; top: 0px; left:0; z-index: 9999999; opacity:1 ;background: rgba(1,1,1,.3); width: 100vw; height: 100vh;display: flex; justify-content: center; align-items: center; overflow-y: hidden;"
>

  <ng-lottie style='position: relative;' [options]="{ path: '/assets/bKash_bird_animation.json' }" width="350px"></ng-lottie>

</div>

